import type { OrganizationContextHeaderProps } from "./organization-context-header.type";

import { Flex } from "antd";

import {
  useOrganizationContextDetail,
  useOrganizationContextList,
} from "@/modules/organization/organization-context";
import { OrganizationContextLoader } from "@/modules/organization/organization-context-loader";
import { OrganizationContextSelect } from "@/modules/organization/organization-context-select";
import { useOrganizationContextSync } from "@/modules/organization/organization-context-sync";
import { OrganizationLogo } from "@/modules/organization/organization-logo";
import { OrganizationPopover } from "@/modules/organization/organization-popover";

import { useOrganizationContextHeaderSizes } from "./organization-context-header.hook";

import "./organization-context-header.style.less";

export const OrganizationContextHeader = (
  props: OrganizationContextHeaderProps
) => {
  const { containerRef, selectStyles } =
    useOrganizationContextHeaderSizes(props);
  const { contextOrganization } = useOrganizationContextDetail();
  const { listLength } = useOrganizationContextList();

  useOrganizationContextSync();

  return (
    <Flex
      ref={containerRef}
      align="center"
      className="organization-context-header"
    >
      {contextOrganization && (
        <div className="organization-context-header-logo">
          <OrganizationPopover
            organization={contextOrganization}
            trigger="click"
            zIndex="layout"
          >
            <OrganizationLogo organization={contextOrganization} iconFallback />
          </OrganizationPopover>
        </div>
      )}
      {(listLength > 1 || !contextOrganization) && (
        <OrganizationContextSelect
          size="large"
          variant="borderless"
          styles={selectStyles}
        />
      )}
      {listLength === 1 && contextOrganization && (
        <div className="organization-context-header-title">
          {contextOrganization.name}
        </div>
      )}
      <OrganizationContextLoader />
    </Flex>
  );
};
